import { Audit } from "@/_models/audit.interface";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { listItemTitle } from "@/_utility/list-item-title.util";
import { RECORD_TYPE_BADGES } from "@/_utility/record-type-badge.util";
import { AssignedItemMetaComponent } from "../assigned-item-meta/assigned-item-meta.component";
import { Component, Input, OnChanges } from "@angular/core";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-audit-task-card",
    standalone: true,
    imports: [SharedComponentsModule, TagModule, AssignedItemMetaComponent],
    templateUrl: "./audit-task-card.component.html",
    styleUrls: [
        "./audit-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class AuditTaskCardComponent implements OnChanges {
    @Input() audit: Audit;

    badge = RECORD_TYPE_BADGES.audit;
    title: string = this.badge.untitledTitle;
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    constructor(private metaService: AssignedItemMetaService) {}

    ngOnChanges(): void {
        this.title = listItemTitle(this.audit, this.badge.untitledTitle);
        this.meta = this.metaService.forAudit(this.audit);
    }
}
